import { KpiStatsItem } from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-stats-item';
import { KpiMetric } from 'src/app/shared/flight-log-api/kpi/kpi.model';
import { DutyRestHoursKpis } from './duty-rest-hours-kpis';
import { DutyTimeKpis } from './duty-time-kpis';
import { FaaFlightTimeKpis } from './faa-flight-time-kpis';
import { HnvgoKpis } from './hnvgo-kpis';
import { NightLandingKpis } from './night-landing-kpis';
import { PilotKpiMetrics } from './pilot-kpi-metrics';
import { PilotKpiStatsViewComponent } from './pilot-kpi-stats-view.component';
import { TotalLandingKpis } from './total-landing-kpis';

export class PilotKpiStatsItemFactory {
  public static create(
    kpiMetric: KpiMetric,
    granularity: string,
    windowSize: number,
  ): KpiStatsItem | undefined {
    switch (kpiMetric.id) {
      case PilotKpiMetrics.DutyRestHours.id: {
        return new KpiStatsItem(
          PilotKpiStatsViewComponent,
          new DutyRestHoursKpis(kpiMetric).createKpi(granularity, windowSize)(),
        );
      }
      case PilotKpiMetrics.Hnvgo.id: {
        return new KpiStatsItem(
          PilotKpiStatsViewComponent,
          new HnvgoKpis(kpiMetric).createKpi(granularity, windowSize)(),
        );
      }
      case PilotKpiMetrics.NightLandings.id: {
        return new KpiStatsItem(
          PilotKpiStatsViewComponent,
          new NightLandingKpis(kpiMetric).createKpi(granularity, windowSize)(),
        );
      }
      case PilotKpiMetrics.TotalLandings.id: {
        return new KpiStatsItem(
          PilotKpiStatsViewComponent,
          new TotalLandingKpis(kpiMetric).createKpi(granularity, windowSize)(),
        );
      }
      case PilotKpiMetrics.FaaFlightTime.id: {
        return new KpiStatsItem(
          PilotKpiStatsViewComponent,
          new FaaFlightTimeKpis(kpiMetric).createKpi(granularity, windowSize)(),
        );
      }
      case PilotKpiMetrics.DutyTime.id: {
        return new KpiStatsItem(
          PilotKpiStatsViewComponent,
          new DutyTimeKpis(kpiMetric).createKpi(granularity, windowSize)(),
        );
      }
    }
  }
}
